module.exports = __webpack_public_path__ + "static/media/sombrero.31b4f0b1.png";